// extracted by mini-css-extract-plugin
export default {"status-box":"RecruitmentStatus_status-box__dsC3k","status-box-warning":"RecruitmentStatus_status-box-warning__366G5","status-box-error":"RecruitmentStatus_status-box-error__Xe4JU"};